import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import createReducers from '../reducers';
import rootSaga from '../sagas';
import activarAtajosModoTrabajo from './activar-atajos-modo-trabajo';
export default function configureStore() {
  var sagaMiddleware = createSagaMiddleware(); //    const store = createStore(reducers, {}, applyMiddleware(sagaMiddleware))

  var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  var store = createStore(createReducers(), {}, composeEnhancers(applyMiddleware(sagaMiddleware)));
  store.dynamicReducers = {};

  store.injectReducer = function (key, reducer) {
    store.dynamicReducers[key] = reducer;
    store.replaceReducer(createReducers(store.dynamicReducers));
    return store;
  };

  sagaMiddleware.run(rootSaga);

  if (window.modoTrabajo) {
    activarAtajosModoTrabajo(store);
  }

  return store;
}